import gql from 'graphql-tag';

export const addPrispevek = gql`
  mutation addPrispevek($input: [PrispevekInput!]!) {
    response: addPrispevek(inputPrispevek: $input) {
      id
    }
  }
`;
